/** 国内酒店帅选 */
import {kpiHotelGetHotelFilterList} from 'api/hotel/hotelApi'
import {kpiHotelGetInterHotelFilterCondition} from 'api'
import {cloneObject} from "@/common/utility/utils";
export default {
  data() {
    return {
      hotelFilters: [], // 国内酒店筛选基本信息
      interHotelFilters: [] // 海外酒店筛选基本信息
    }
  },
  methods: {
    getHotelFilters(data, callback) {
      // 如果没有用户信息，请求接口
      kpiHotelGetHotelFilterList(data).then((res) => {
        this.hotelFilters = this.getFilters(res.ResultData || []);
        if (callback && typeof callback === 'function') {
          callback(this.hotelFilters)
        }
      });
    },

    // 获取用户权限
    getInterHotelFilters(data) {
      // 如果没有用户权限，请求接口
      kpiHotelGetInterHotelFilterCondition(data).then((res) => {
        this.interHotelFilters = this.getFilters(res.ResultData || []);
        return this.interHotelFilters;
      });
    },

    getFilters (list = []) {
      let newList = cloneObject(list)
      return newList.map(m => {
        return {
          ...m,
          Conditions: this.getFilterConditions(m.Conditions, m, m.TypeName)
        }
      })
    },

    getFilterConditions (Conditions, m, Name) {
      if (Conditions) {
        return Conditions.map(v => {
          return {
            ...v,
            CityCode: m.CityId,
            CityName_CN: m.CityName,
            CityName_EN: m.CityName_EN,
            CityName_JP: m.CityName_JP,
            CityID: m.CityId,
            CountryName_CN: m.CountryName,
            CountryName_EN: m.CountryName_EN,
            CountryName_JP: m.CountryName_JP,
            IsMuitSelect: m.IsMuitSelect,
            ParentName: Name,
            Type: m.Type,
            TypeName: m.TypeName,
            FilterType: m.FilterType,
            selected: false,
            Conditions: this.getFilterConditions(v.Conditions, m, v.Name)
          }
        })
      }
    }
  }
}
